import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { Globals } from 'src/app/globals';
import { AdmService } from '../../../service/adm.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Component({
  selector: 'app-application-marital-status',
  templateUrl: './application-marital-status.component.html',
  styleUrls: ['./application-marital-status.component.scss']
})
export class ApplicationMaritalStatusComponent implements OnInit {

  showLoader: boolean = false;
  martialStatuses: any;
  currentAppStatusName: any;
  currentAppStatusId = 0;

  constructor(private toastrService: ToastrService, public admService: AdmService, public globals: Globals, private router: Router, public translate: TranslateService) { }

  ngOnInit(): void {
    this.getAllMartialStatuses();
  }

  getAllMartialStatuses() {
    this.showLoader = true;
    this.admService.getMartialStatuses()
      .subscribe(
        data => {
          this.martialStatuses = data;
          this.updateTable();
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_MARTIAL_STATUS'));
          this.showLoader = false
        },
        () => this.showLoader = false
      );

  }

  updateTable() {
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
      // Setup - add a text input to each footer cell
      $('#example thead tr').clone(true).appendTo('#example thead');
      $('#example thead tr:eq(1) th').each(function (i: any) {
        var title = $($('#example thead tr:eq(1) th')[i]).text();
        $($('#example thead tr:eq(1) th')[i]).html('<input type="text" placeholder="Search ' + title + '" />');

        $('input', $('#example thead tr:eq(1) th')[i]).on('keyup change', function () {
          if (table.column(i).search() !== $('#example thead tr:eq(1) th')[i].value) {
            table
              .column(i)
              .search($('#example thead tr:eq(1) th')[i].value)
              .draw();
          }
        });
      });
      var table = $("#datatable").DataTable({
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        responsive: true,
        orderCellsTop: true,
        fixedHeader: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // "columnDefs": [
        //   { "orderable": false, "targets": [8] }
        // ],
        pageLength: 5,
        lengthChange: false,
        info: true,
        searching: false,
        // search: {
        //   searchPlaceholder: "Search",
        // },
        paging: true,
        // language: {
        //   search: "",
        //   searchPlaceholder: "Search",
        // },
        // buttons: [
        //   'excel', 'pdf'
        // ]
        buttons: [{
          extend: 'csvHtml5',
          text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
          titleAttr: 'CSV'
        },
        {
          extend: 'pdfHtml5',
          text: '<span style="font-size: 3em; color: #e04006;"><i class="fas fa-file-pdf fa-sm"></i></span>',
          titleAttr: 'PDF'
        }]
      });
    }, 2);
  }

  editAppStatus(id: any) {
    this.router.navigate(
      ['admission/update-marital-status'],
      { queryParams: { martialStatus: id } });
  }

  deleteMartialStatus(id: any) {
    this.admService.deleteMartialStatuses(id)
      .subscribe(
        data => {
          window.location.reload();
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_DELETE_MARTIAL_STATUS'));

        }
      );
  }

  getCurrentAppStatus(appStatusId: any) {
    let getAppStatus = this.martialStatuses.filter((i: any) => i.id == appStatusId)[0];
    this.currentAppStatusName = this.globals.lang == "en" ? getAppStatus.maritalStatusNameEn : getAppStatus.maritalStatusNameAr;
    this.currentAppStatusId = appStatusId;
  }
}
